export default __webpack_public_path__ + "static/media/01 - Folder (1).a6df72ee.png";